import React from "react";
import { TextOqt } from "../";

export const NumberOqt = (props) => {
    return <TextOqt {...props} value="" type="number"/>;
}
